import { AddressBook } from 'components/delivery/AddressBook';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const AddressBookPage: React.FC = () => {
    const { t } = useTranslation();
    return <AddressBook title={t('DELIVERY_ADDRESS_TITLE')} />;
};
